package fi.bullpen.kmpapp.screens.generic

sealed interface UserActionState {
    sealed interface AwaitingAction : UserActionState
    data object Available : AwaitingAction
    data object InProgress : UserActionState
    data class Error(val message: String) : AwaitingAction
}
